import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, STANDARD_HEALTH_PROFILES_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const StandardHealthProfilesPage = lazy(() => import('./pages/StandardHealthProfilesPage'));

export const STANDARD_HEALTH_PROFILES_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.STANDARD],
    component: () => <StandardHealthProfilesPage />,
    displayTitle: () => 'Health Profiles',
    pageType: PageType.PRIVATE,
    path: STANDARD_HEALTH_PROFILES_PATH,
    serviceCatalogCode: '',
  },
];
